<template>
    <div class="tiepai-management">
        <!-- 贴牌管理 -->
        <div class="section">
            <el-form :model="tiepaiForm" class="tiepai-form" label-width="120px">
                <h2 class="section-title">贴牌信息</h2>
                <el-form-item label="贴牌名称">
                    <el-input v-model="tiepaiForm.tiepai_name" placeholder="请输入贴牌名称" class="form-input" />
                </el-form-item>
                <el-form-item label="贴牌头像">
                    <div class="upload-container">
                        <el-input v-model="tiepaiForm.tiepai_head" placeholder="请输入贴牌头像 URL" class="form-input" />
                        <el-button type="success" @click="handleUploadAvatar">
                            <el-icon>
                                <Upload />
                            </el-icon> 上传头像
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="浏览器图标">
                    <div class="upload-container">
                        <el-input v-model="tiepaiForm.tiepai_favicon" placeholder="请输入浏览器图标 URL" class="form-input" />
                        <el-button type="success" @click="handleUploadFavicon">
                            <el-icon>
                                <Upload />
                            </el-icon> 上传图标
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="代理域名">
                    <el-input v-model="tiepaiForm.agent_host" placeholder="请输入代理域名" disabled class="form-input" />
                </el-form-item>
                <el-form-item class="form-buttons">
                    <el-button type="primary" @click="updateTiepaiInfo">保存修改</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-divider></el-divider>

        <!-- 版权备案信息管理 -->
        <div class="section">
            <h2 class="section-title">网站版权备案信息</h2>
            <div class="copyright-list">
                <div v-for="(item, index) in copyrightList" :key="index" class="copyright-item-row">
                    <el-input v-model="item.key" placeholder="备案号/版权名称" class="copyright-key" />
                    <el-input v-model="item.value" placeholder="链接地址" class="copyright-value" />
                    <!-- 改为 -->
                    <el-button type="danger" @click="removeCopyright(index)" circle size="small">
                        <el-icon>
                            <Delete />
                        </el-icon>
                    </el-button>
                </div>
                <el-button type="primary" @click="addCopyright" class="add-copyright-btn">
                    <el-icon>
                        <Plus />
                    </el-icon> 添加版权信息
                </el-button>
            </div>
            <div class="form-buttons" style="margin-top: 20px;">
                <el-button type="primary" @click="saveCopyrightInfo">保存版权信息</el-button>
            </div>
        </div>

        <el-divider></el-divider>

        <!-- 小程序管理 -->
        <div class="section">
            <el-form :model="miniAppForm" ref="miniAppFormRef" class="mini-app-form" label-width="120px">
                <h2 class="section-title">小程序管理</h2>
                <el-form-item label="APPID">
                    <el-input v-model="miniAppForm.app_id" placeholder="请输入APPID" class="form-input" />
                </el-form-item>
                <el-form-item label="APP Secret">
                    <el-input v-model="miniAppForm.app_secret" placeholder="请输入APP Secret" class="form-input" />
                </el-form-item>
                <el-form-item label="上传密钥">
                    <el-input type="textarea" v-model="miniAppForm.upload_key" placeholder="请输入上传密钥" class="form-input"
                        :rows="4" resize="none" />
                </el-form-item>
                <el-form-item label="接口地址">
                    <el-input v-model="miniAppForm.app_url" placeholder="请输入接口地址" class="form-input" />
                </el-form-item>
                <el-form-item class="form-buttons">
                    <el-button type="primary" @click="updateMiniAppInfo">保存修改</el-button>
                    <el-button type="success" @click="handleUploadCode" :loading="uploading">上传代码</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import { auth } from '@/utils/auth.js';
import config from '@/config.js';
import { beforeUpload, uploadToOSS, getUploadSignature } from '@/utils/uploadUtils';
import { Upload, Plus, Delete } from '@element-plus/icons-vue';

export default {
    name: 'TiepaiManagement',
    components: {
        Upload,
        Plus,
        Delete
    },
    data() {
        return {
            username: '',
            uploading: false,
            tiepaiForm: {
                tiepai_name: '',
                tiepai_head: '',
                agent_host: '',
                tiepai_favicon: '',
            },
            miniAppForm: {
                app_id: '',
                app_secret: '',
                upload_key: '',
                app_url: '',
            },
            copyrightList: [], // 版权信息列表
        };
    },
    methods: {
        async handleUploadAvatar() {
            try {
                const fileInput = document.createElement('input');
                fileInput.type = 'file';
                fileInput.accept = 'image/*';
                fileInput.onchange = async (event) => {
                    const file = event.target.files[0];
                    if (!file) return;

                    const isValid = await beforeUpload(file, {
                        maxSize: 5,
                        allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
                    });
                    if (!isValid) return;

                    const signatureData = await getUploadSignature('image');
                    if (!signatureData) {
                        ElMessage.error("获取上传签名失败");
                        return;
                    }

                    const uploadResult = await uploadToOSS(file, signatureData);
                    if (uploadResult.success) {
                        ElMessage.success("头像上传成功");
                        this.tiepaiForm.tiepai_head = uploadResult.url;
                    } else {
                        ElMessage.error("头像上传失败");
                    }
                };
                fileInput.click();
            } catch (error) {
                console.error("上传头像失败:", error);
                ElMessage.error("上传头像失败，请重试");
            }
        },

        async handleUploadFavicon() {
            try {
                const fileInput = document.createElement('input');
                fileInput.type = 'file';
                fileInput.accept = 'image/*';
                fileInput.onchange = async (event) => {
                    const file = event.target.files[0];
                    if (!file) return;

                    const isValid = await beforeUpload(file, {
                        maxSize: 5,
                        allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
                    });
                    if (!isValid) return;

                    const signatureData = await getUploadSignature('image');
                    if (!signatureData) {
                        ElMessage.error("获取上传签名失败");
                        return;
                    }

                    const uploadResult = await uploadToOSS(file, signatureData);
                    if (uploadResult.success) {
                        ElMessage.success("浏览器图标上传成功");
                        this.tiepaiForm.tiepai_favicon = uploadResult.url;
                    } else {
                        ElMessage.error("浏览器图标上传失败");
                    }
                };
                fileInput.click();
            } catch (error) {
                console.error("上传图标失败:", error);
                ElMessage.error("上传图标失败，请重试");
            }
        },

        // 添加版权信息
        addCopyright() {
            this.copyrightList.push({
                key: '',
                value: ''
            });
        },

        // 删除版权信息
        removeCopyright(index) {
            this.copyrightList.splice(index, 1);
        },

        // 保存版权信息
        async saveCopyrightInfo() {
            // 过滤掉空数据
            const validCopyright = this.copyrightList.filter(item => item.key.trim() !== '');


            try {
                const response = await axios.post(
                    `${config.BASE_URL}/agent/api/agent_api.php`,
                    {
                        action: 'update_copyright',
                        username: this.username,
                        copyright: JSON.stringify(validCopyright)
                    }
                );

                if (response.data.success) {
                    ElMessage.success('版权信息保存成功');
                } else {
                    ElMessage.error(response.data.message || '保存失败');
                }
            } catch (error) {
                console.error('保存版权信息失败:', error);
                ElMessage.error('保存失败，请检查网络连接');
            }
        },

        async fetchTiepaiInfo() {
            try {
                const user = auth.getStoredUser();
                if (!user) {
                    this.$message.error('未登录，请重新登录');
                    this.$router.push('/login');
                    return;
                }
                this.username = user.username;

                // 查询贴牌信息
                const tiepaiResponse = await axios.post(
                    `${config.BASE_URL}/agent/api/agent_api.php`,
                    { action: 'query', username: this.username }
                );

                if (tiepaiResponse.data.success) {
                    this.tiepaiForm = {
                        tiepai_name: tiepaiResponse.data.data.tiepai_name || '',
                        tiepai_head: tiepaiResponse.data.data.tiepai_head || '',
                        tiepai_favicon: tiepaiResponse.data.data.tiepai_favicon || '',
                        agent_host: tiepaiResponse.data.data.agent_host || '',
                    };

                    // 获取版权信息
                    if (tiepaiResponse.data.data.copyright) {
                        try {
                            const copyright = JSON.parse(tiepaiResponse.data.data.copyright);
                            if (Array.isArray(copyright)) {
                                this.copyrightList = copyright;
                            } else {
                                this.copyrightList = [];
                            }
                        } catch (e) {
                            this.copyrightList = [];
                        }
                    } else {
                        this.copyrightList = [];
                    }
                } else {
                    this.$message.error(tiepaiResponse.data.message || '查询贴牌信息失败');
                }

                // 查询小程序管理信息
                const miniAppResponse = await axios.post(
                    `${config.BASE_URL}/agent/api/agent_api.php`,
                    { action: 'query_mini', username: this.username }
                );

                if (miniAppResponse.data.success) {
                    this.miniAppForm = {
                        app_id: miniAppResponse.data.data.app_id || '',
                        app_secret: miniAppResponse.data.data.app_secret || '',
                        upload_key: miniAppResponse.data.data.upload_key || '',
                        app_url: miniAppResponse.data.data.app_url || '',
                    };
                } else {
                    this.miniAppForm = {
                        app_id: '',
                        app_secret: '',
                        upload_key: '',
                        app_url: '',
                    };
                }
            } catch (error) {
                console.error('查询贴牌信息失败:', error);
                this.$message.error('查询贴牌信息失败，请检查网络连接');
                this.miniAppForm = {
                    app_id: '',
                    app_secret: '',
                    upload_key: '',
                    app_url: '',
                };
            }
        },

        async updateTiepaiInfo() {
            try {
                const response = await axios.post(
                    `${config.BASE_URL}/agent/api/agent_api.php`,
                    {
                        action: 'update',
                        username: this.username,
                        tiepai_name: this.tiepaiForm.tiepai_name,
                        tiepai_head: this.tiepaiForm.tiepai_head,
                        tiepai_favicon: this.tiepaiForm.tiepai_favicon,
                        agent_host: this.tiepaiForm.agent_host,
                    }
                );

                if (response.data.success) {
                    this.$message.success('贴牌信息保存成功');
                } else {
                    this.$message.error(response.data.error || '保存失败');
                }
            } catch (error) {
                console.error('保存贴牌信息失败:', error);
                this.$message.error('保存失败，请检查网络连接');
            }
        },

        async updateMiniAppInfo() {
            try {
                const response = await axios.post(
                    `${config.BASE_URL}/agent/api/agent_api.php`,
                    {
                        action: 'update_mini',
                        username: this.username,
                        app_id: this.miniAppForm.app_id,
                        app_secret: this.miniAppForm.app_secret,
                        upload_key: this.miniAppForm.upload_key,
                        app_url: this.miniAppForm.app_url,
                    }
                );

                if (response.data.success) {
                    this.$message.success('小程序信息保存成功');
                } else {
                    this.$message.error(response.data.error || '保存失败');
                }
            } catch (error) {
                console.error('保存小程序信息失败:', error);
                this.$message.error('保存失败，请检查网络连接');
            }
        },

        async handleUploadCode() {
            console.log('上传代码方法被触发');
            const payload = {
                appid: this.miniAppForm.app_id,
                privateKeyContent: this.miniAppForm.upload_key,
                api_url: this.miniAppForm.app_url,
            };

            try {
                this.uploading = true;
                const response = await axios.post('https://djk.huijp.cn/mini/upload.php', payload);
                if (response.data.status === 'success') {
                    ElMessageBox.alert(
                        '恭喜你代码已上传成功，请登录：https://mp.weixin.qq.com/ 进行管理！',
                        '上传成功',
                        { confirmButtonText: '确定' }
                    );
                } else {
                    ElMessage.error(`上传失败: ${response.data.message || '未知错误'}`);
                }
            } catch (error) {
                console.error('上传过程中发生错误:', error);
                ElMessage.error('上传过程中发生错误，请稍后重试！');
            } finally {
                this.uploading = false;
            }
        },
    },
    created() {
        const user = auth.getStoredUser();
        if (user && user.username) {
            this.username = user.username;
            this.fetchTiepaiInfo();
        } else {
            this.$message.error('未登录，请重新登录');
            this.$router.push('/login');
        }
    },
};
</script>

<style scoped>
.tiepai-management {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section {
    background-color: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section-title {
    text-align: left;
    /* 改为左对齐 */
    font-size: 20px;
    /* 稍微调小一点字体 */
    font-weight: bold;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 4px solid #409eff;
    /* 添加左侧边框装饰 */
}

.tiepai-form,
.mini-app-form {
    width: 100%;
    max-width: 800px;
    /* 增加最大宽度，让表单更宽 */
    margin: 0;
    /* 移除 margin: 0 auto，取消居中 */
}

.el-form-item {
    width: 100%;
    margin-bottom: 20px;
}

.form-input {
    width: 100%;
}

.form-buttons {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
}

.upload-container {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.upload-container .el-input {
    flex: 1;
}

/* 版权信息列表样式 */
.copyright-list {
    max-width: 800px;
    margin: 0;
    /* 移除 margin: 0 auto，取消居中 */
}

.copyright-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
}

.copyright-key {
    flex: 1;
}

.copyright-value {
    flex: 2;
}

.add-copyright-btn {
    margin-top: 10px;
}

@media (max-width: 768px) {
    .tiepai-management {
        padding: 10px;
    }

    .section {
        padding: 15px;
    }

    .tiepai-form,
    .mini-app-form {
        max-width: 100%;
    }

    .upload-container {
        flex-direction: column;
    }

    .upload-container .el-button {
        width: 100%;
    }

    .copyright-item-row {
        flex-direction: column;
    }

    .copyright-key,
    .copyright-value {
        width: 100%;
    }

    .form-buttons {
        flex-direction: column;
    }

    .form-buttons .el-button {
        width: 100%;
    }
}
</style>